import CARD_0_IMAGE from "../static/img/cards/0.svg";
import CARD_1_IMAGE from "../static/img/cards/1.svg";
import CARD_2_IMAGE from "../static/img/cards/2.svg";
import CARD_3_IMAGE from "../static/img/cards/3.svg";
import CARD_4_IMAGE from "../static/img/cards/4.svg";
import CARD_5_IMAGE from "../static/img/cards/5.svg";
import CARD_6_IMAGE from "../static/img/cards/6.svg";
import CARD_7_IMAGE from "../static/img/cards/7.svg";
import CARD_8_IMAGE from "../static/img/cards/8.svg";
import CARD_9_IMAGE from "../static/img/cards/9.svg";
import CARD_10_IMAGE from "../static/img/cards/10.svg";

export const RULE_1 = {
  number: "ASC",
  title: "Tap all the numbers in the ascending order",
  titleColor: "#7033d3",
};

export const RULE_2 = {
  title: "Tap all the circles",
  titleColor: "#7033d3",
  validate: function (item) {
    if (item.imgSrc === CARD_0_IMAGE || item.imgSrc === CARD_6_IMAGE) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_3 = {
  title: "Tap all the multiples of 4",
  titleColor: "#75c366",
  validate: function (item) {
    if (parseInt(item.number, 10) % 4 === 0) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_4 = {
  title: "Tap all the blue shapes",
  titleColor: "#7033d3",
  validate: function (item) {
    if (item.imgSrc === CARD_5_IMAGE || item.imgSrc === CARD_10_IMAGE) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_5 = {
  title: "Tap all the 3s",
  titleColor: "#7033d3",
  validate: function (item) {
    if (parseInt(item.number, 10) === 3) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_6 = {
  title: "Tap all the squares",
  titleColor: "#7033d3",
  validate: function (item) {
    if (item.imgSrc === CARD_5_IMAGE || item.imgSrc === CARD_2_IMAGE) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_7 = {
  title: "Tap all the multiples of 2",
  titleColor: "#7033d3",
  validate: function (item) {
    if (parseInt(item.number, 10) % 2 === 0) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_8 = {
  title: "Tap all the pentagons",
  titleColor: "#7033d3",
  validate: function (item) {
    if (item.imgSrc === CARD_4_IMAGE || item.imgSrc === CARD_9_IMAGE) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_9 = {
  title: "Tap all the odd numbers",
  titleColor: "#7033d3",
  validate: function (item) {
    if (parseInt(item.number & 2 !== 0)) {
      return true;
    } else {
      return false;
    }
  },
};

export const RULE_10 = {
  title: "Tap all the triangles",
  titleColor: "#7033d3",
  validate: function (item) {
    if (item.imgSrc === CARD_1_IMAGE || item.imgSrc === CARD_10_IMAGE) {
      return true;
    } else {
      return false;
    }
  },
};

// export const RULE_5 = {
//   title: "alien",
//   titleColor: "#7033d3",
//   imageSrc: skullImg,
//   validate: function (item) {
//     if (item.imgSrc === this.imageSrc) {
//       return true;
//     } else {
//       return false;
//     }
//   },
// };

// export const RULE_6 = {
//   title: "binary digit",
//   titleColor: "#7033d3",
//   validate: function (item) {
//     if (item.number == "01" || item.number == "10" || item.number == "00") {
//       return true;
//     } else {
//       return false;
//     }
//   },
// };

// export const RULE_7 = {
//   title: "even number",
//   titleColor: "#7033d3",
//   validate: function (item) {
//     if (parseInt(item.number, 10) % 2 === 0) {
//       return true;
//     } else {
//       return false;
//     }
//   },
// };

// export const RULE_8 = {
//   title: "animal",
//   titleColor: "#7033d3",
//   validate: function (item) {
//     if (item.imgSrc === catImg || item.imgSrc === fishImg) {
//       return true;
//     } else {
//       return false;
//     }
//   },
// };
